import React from "react";
import { useIntl } from "react-intl";
import { Modal } from "@jelly/ui";

import styles from "./Modals.module.scss";
import { messages } from "../Mixing.messages";
import { useBlocks, useUi } from "@jelly/lesson";
import * as appConfig from "appConfig";
import { nl2p } from "@src/utils/nl2p";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

type ModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;

export const PanningSingleModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_PanningSingle_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_PanningSingle_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_panning_1.png`}
                    />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_panning_2.png`}
                    />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const PanningStereoModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_PanningStereo_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_PanningStereo_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_panning_stereo_1.png`}
                    />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_panning_stereo_2.png`}
                    />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const UpmixingModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_Upmixing_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_Upmixing_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_upmixing_1.png`}
              />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const MultiInstancesModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_MultiInstances_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_MultiInstances_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_multi_instances_1.png`}
                    />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_multi_instances_2.png`}
                    />
                  </div>
                </div>,
                <div key={3} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_multi_instances_3.png`}
                    />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const QuadBusModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_QuadBus_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_QuadBus_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_quadbus_1.png`}
                    />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_quadbus_2.png`}
                    />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const ThreeDReverbModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_3dReverb_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_3dReverb_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_3d_reverb_1.png`}
              />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const LfeModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P4_M_Lfe_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P4_M_Lfe_Description))}</div>
          <div className={styles.rightColumn}>
            {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
            <SpatialCarousel showBreadcrumbs>
              {[
                <div key={1} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_lfe_1.png`}
                    />
                  </div>
                </div>,
                <div key={2} className={styles.carouselItem}>
                  <div className={styles.image}>
                    <blocks.image
                      src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/page04/modals/modal_lfe_2.png`}
                    />
                  </div>
                </div>,
              ]}
            </SpatialCarousel>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};
